"use client"

import { useNavigate } from "react-router-dom"

const LoadingOverlay = ({ uploadProgress, mode = "order" }) => {
  const navigate = useNavigate()

  const isDocumentMode = mode === "documents"

  return (
    <div className="order-loading-overlay">
      <div className="order-loading-container">
        <div className="order-spinner-section">
          <div className="order-spinner"></div>
          <p className="order-loading-text">
            {isDocumentMode ? "Uploading your documents..." : "Processing your order..."}
          </p>
        </div>

        {(uploadProgress.po > 0 || uploadProgress.payment > 0 || Object.values(uploadProgress.documents || {}).some(p => p > 0)) && (
          <div className="order-upload-progress">
            {uploadProgress.po > 0 && <p>PO File: {Math.round(uploadProgress.po)}%</p>}
            {uploadProgress.payment > 0 && <p>Payment Proof: {Math.round(uploadProgress.payment)}%</p>}
            {uploadProgress.documents && Object.entries(uploadProgress.documents).map(([doc, prog]) => 
              prog > 0 && <p key={doc}>{doc.replace(/([A-Z])/g, ' $1').trim()}: {Math.round(prog)}%</p>
            )}
          </div>
        )}

        {/* Only show Cancel button during final order submission */}
        {!isDocumentMode && (
          <button className="order-cancel-btn" onClick={() => navigate("/dashboard")}>
            Cancel & Go to Dashboard
          </button>
        )}
      </div>
    </div>
  )
}

export default LoadingOverlay